/*class AddMore
{
    constructor(s_add, s_add_in, s_add_more, s_remove, tpl){
        this.s_add      =   s_add;
        this.s_add_in   =   s_add_in;
        this.s_add_more =   s_add_more;
        this.s_remove   =   s_remove;
        this.tpl        =   tpl;

        this.o_add      =   jQuery(this.s_add);
        this.o_add_in   =   jQuery(this.s_add_in);
        this.o_add_more =   jQuery(this.s_add_more);
        this.o_remove   =   jQuery(this.s_remove);

        this.t_cnt      =   jQuery(this.s_add_in+" > span").length

    }
    BindAdd(){
        if(this.o_add.length == 1)
        {
            this.o_add.on('click',function(){

            });
        }
    }
}*/

var displaybanner='';
var Isdisplaybanner;
var UrlSignInPage;
var UrlSignUpPage;
var total_record;
var addressFull;
var is_search;
var GEOID;
var Url_GAR = XHR_Url+'/ajax',Url_GUS = XHR_Url+'/suggestion';
var viewProperty = 0;
function loading(s,b_s,l_in,s_name,icon){
    if(s == true){
        if(!l_in){l_in = '.loading-area';}if(!s_name){s_name = 'Loading';}if(!icon){icon = '<i class="fa fa-spinner fa-pulse fa-2x text-primary"></i>&nbsp;';}
        if(b_s !== '' && b_s !==null && b_s !== false){
            jQuery(b_s).attr('disabled', 'disabled');
        }
        jQuery(l_in).append('<div class="processing"><p>'+icon+s_name+'</p></div>');
    }
    else
    {
        if(b_s !== '' && b_s !== null && b_s !== false)
        {
            jQuery(b_s).removeAttr('disabled');
        }
        jQuery('.processing').remove();
    }
}
function msgNotify(m,mt,l_in)
{
    if(!m || !mt) return false;
    if(mt == 'error'){mt='danger';}
    var malert= '<div class="alert alert-dismissible alert-'+mt+' " role="alert"><button type="button" class="alert-close p-0" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button><strong  class="fa"></strong>'+m+'</div>';
    jQuery(l_in).html(malert);
}
function bind_address_autosuggest()
{

    var s_type = 'buy';
    jQuery("label.btn-stype").on("click",function(){
        s_type = jQuery(this).find("input[type='radio']").val();

        if(s_type == 'new-project')
        {
            jQuery("#search-location").hide();
            //jQuery(this).closest("form").attr('action',Site_Root+PRECONSTRUCTION_URL);
            jQuery(this).closest("form").attr('action',Site_Root+PC_LST_NEW_URL);
        }
        else
        {
            jQuery("#search-location").show();
            jQuery(this).closest("form").attr('action',Site_Root+SEARCH_URL);
        }
    });
    if(jQuery("#AddressName").length > 0 && jQuery().selectize)
    {
        var test = jQuery("#AddressName").selectize({
            options: [{type: 'cur_loc', title: 'Current Location'}],
            plugins: ['restore_on_type'],// restore_on_backspace
            delimiter:',',
            valueField: 'title',
            labelField: 'title',
            searchField: 'title',
            sortField: 'title',
            maxItems: 1,
            maxOptions: 100,
            //highlight: true,
            //addPrecedence:true,
            persist: false,
            selectOnTab:false,
            create: true,
            createOnBlur: true,
            //placeholder: place,
            //copyClassesToDropdown: false,
            openOnFocus: true,
            optgroups:
                [
                    //{$order: 6, typeid: 'agent', typename: 'Agent'},
                    {$order: 7, typeid: 'bn'  , typename: 'BUILDING NAME'},
                    {$order: 6, typeid: 'area', typename: 'AREA'},
                    {$order: 5, typeid: 'mls' , typename: 'MLS#'},
                    {$order: 4, typeid: 'zip' , typename: 'ZIP'},
                    {$order: 3, typeid: 'add' , typename: 'ADDRESS'},
                    {$order: 2, typeid: 'sub' , typename: 'NEIGHBORHOOD'},
                    {$order: 1, typeid: 'cs'  , typename: 'CITIES'},
                    //{$order: 1, typeid: 'county', typename: 'County'},
                ],
            optgroupField: 'type',
            optgroupLabelField: 'typename',
            optgroupValueField: 'typeid',
            //lockOptgroupOrder: true,
            optgroupOrder: ['cs','sub', 'zip', 'add', 'mls', 'area', 'bn'],
            render: {
                optgroup_header: function(data, escape) {
                    return '<div class="group-header '+data.typename +'">' + escape(data.typename) + '</div>';
                },

            },
            load: function(query, callback) {
                if (!query.length || query.length < 3) return callback();
                jQuery.jAjaxCall({
                    abort_on_new_req    :   true,
                    send_data: [{name: 'q', value:query},{name: 's', value:s_type}],
                    xhr_area: 'SiteSearch',
                    xhr_module: 'Suggestion',
                    xhr_action: 'Get',
                    xhr_url: Url_GUS,
                    skip_pr: true,
                    /*fn_alert: function (mt, m) {},*/
                    callbefore_send: function (jqXHR, settings) {
                    },
                    callback_on_success: function (data, textStatus, jqXHR) {
                        if(data.DATA !== undefined || data.DATA != 'undefined'){
                            callback(data.DATA);
                        }
                    },
                    callback_on_error: function (jqXHR, textStatus, errorThrown) {
                        callback();
                    },
                    callback_on_complete: function (jqXHR, textStatus) {
                        jQuery("form#search .selectize-control").removeClass('loading');
                        jQuery("form#ms-filter-form .selectize-control").removeClass('loading');
                    }
                }, 'sitesearch');
            },
            onChange: function(e){
                console.log('im from common.js');

                if(this.options[e] != undefined) {
                    if (this.options[e].type == 'cur_loc') {

                        if (navigator.geolocation) {
                            navigator.geolocation.getCurrentPosition(function (position) {
                                var pos = {
                                    lat: position.coords.latitude,
                                    lng: position.coords.longitude
                                };
                                console.log('LAT : ' + position.coords.latitude);
                                console.log('LONG : ' + position.coords.longitude);

                                jQuery('#Latitude').val(position.coords.latitude);
                                jQuery('#Longitude').val(position.coords.longitude);
                                jQuery('#MapCenterLat').val(position.coords.latitude);
                                jQuery('#MapCenterLng').val(position.coords.longitude);

                            });

                            jQuery('#AddressValue').val('');
                            jQuery('#AddressType').val('');
                        }
                    } else if (this.options[e].type == 'add') {
                        if (jQuery('input[name="ListingID_MLS"]').length > 0) {
                            jQuery('input[name="ListingID_MLS"]').remove();
                        }
                        jQuery("#ms-filter-form, #SearchResultForm").append('<input type="hidden" name="ListingID_MLS" value="' + this.options[e].ListingID_MLS + '"/>');
                        jQuery('#AddressValue').val(this.options[e].title);
                        jQuery('#AddressType').val(this.options[e].type);

                        jQuery('#Latitude').val('');
                        jQuery('#Longitude').val('');
                        jQuery('#MapCenterLat').val('26.1935484');
                        jQuery('#MapCenterLng').val('-80.3408449');
                    } else if (this.options[e].type == 'sub') {

                        if (jQuery('input[name="ListingID_MLS"]').length > 0) {
                            jQuery('input[name="ListingID_MLS"]').remove();
                        }
                        this.options[e].type = 'all';
                        jQuery("#ms-filter-form, #SearchResultForm").append('<input type="hidden" name="ListingID_MLS" value="' + this.options[e].ListingID_MLS + '"/>');
                        jQuery('#AddressValue').val(this.options[e].title);
                        jQuery('#AddressType').val(this.options[e].type);
                    }
                    else {
                        jQuery('#AddressValue').val(this.options[e].title);
                        if (this.options[e].type == '' || this.options[e].type == null)
                            this.options[e].type = 'all';

                        jQuery('#Latitude').val('');
                        jQuery('#Longitude').val('');
                        jQuery('#MapCenterLat').val('26.1935484');
                        jQuery('#MapCenterLng').val('-80.3408449');

                        jQuery('#AddressType').val(this.options[e].type);
                    }
                }
            },
        });
    }

}
function bindLRBar(){
    var WW              = jQuery(window).width();
    var WH              = jQuery(window).height();
    
    console.log(WW);
    
    //if(WW > '7980')
    if(viewport.is('md') === true)
    {
        var h_r_bar = jQuery('#h-r-bar').height();
        var s_scroll = h_r_bar - WH + 163;

        $(window).scroll(function(){
            var banner_h = Math.max(0, window.scrollY);

            /* Scroll Down*/
            if(banner_h > s_scroll)
            {
                jQuery('#h-l-bar').css({'top' : s_scroll + 'px','position' : 'relative'});
            }

            /* Scroll Top*/
            if(banner_h < s_scroll)
            {
                jQuery('#h-l-bar').css({'top' : '0px','position' : 'fixed','width': jQuery('#rbar').width()});
            }
        });
    }
}

function bindCUSTOMpopup()
{

    /*if(jQuery('#pt-bar').length > 0) {
        jQuery('#pt-bar').addClass('affix');
        jQuery('#pt-bar').width(jQuery('#pl-bar').width()-30);
        jQuery(".te-prop-features").css({
            'margin-top': jQuery("#pt-bar").height()+40
        });
        setTimeout(function () {
            if(popup_status == 'true')
            {
                jQuery('#pt-bar').affix({
                    offset: {
                    }
                });
            } else {
                jQuery('#pt-bar').affix({
                    offset: {
                        bottom: jQuery('footer').outerHeight(true)-jQuery("#pt-bar").height()+110
                    }
                });
            }

        },50);
    }*/
    //var width = jQuery('#pt-bar').width(jQuery('#pl-bar').width()-30);addDomListener
    
    
    jQuery('.popup-modal-custom').unbind('click');
    jQuery('.popup-modal-custom').unbind().on('click',function(e){


        // jQuery( "#modal-popup-custom" ).bind( ".popup-modal-custom" );
        //$( "#modal-popup-custom" ).unbind( "click", bindCUSTOMpopup ).text( "Does nothing..." );

        // jQuery('#modal-popup-custom').modal('toggle');
        if(jQuery('#modal-popup-custom').is(":visible"))
        {
            jQuery('#modal-popup-custom').modal('hide');
            jQuery('#modal-popup-custom .modal-content').html('');
            jQuery('.modal-backdrop').remove();
            jQuery("#modal-popup-custom").removeAttr("style");
        }
        //rebate();
        // if(jQuery('#rebate_calculate').length > 0) {
        //     rebate_calculation();
        // }
        if (typeof(AllowRegNum) != undefined && AllowRegNum != '' && typeof(SessionPropViewCount) != undefined && SessionPropViewCount != '' && IsUserLogged == false && ((AllowRegNum + 1) <= SessionPropViewCount)){
console.log(IsUserLogged,'erer');
                var url = jQuery('#site-login #modal-login-form').attr('data-url');
                var type = jQuery('#site-login #modal-login-form').attr('data-target');

                jQuery('#modal-popup-md .modal-content').html('<p class="text-center"><br>Loading ...</p>');
                jQuery('#modal-popup-md').modal('show');

                jQuery('#modal-popup-md .modal-content').load(url, function () {
                    if (typeof (type) != undefined && type != '')
                        forcedSignInPopup(type);
                });
        }else {
            var url = jQuery(this).attr('data-url');
            var type = jQuery(this).attr('data-target');

            header_url = url.replace('popup', '')
            window.history.replaceState(null, null, header_url);

            //jQuery('#modal-popup-custom .modal-content').prepend('<button type="button" class="close" data-dismiss="modal" id="popup_close" aria-label="Close"><span aria-hidden="true">×</span></button>');
            jQuery('#modal-popup-custom .modal-content').html('<p class="text-center"><br>Loading ...</p>');
            jQuery('#modal-popup-custom').modal('show');
            jQuery('#modal-popup-custom .modal-content').load(Site_Root + url, function (e) {
                jQuery(".quick-access").addClass("quick-access-popup");
                //ptBarPosition();
                // bindCUSTOMpopup();
                //$(document).ready(function() {
                /*jQuery('#Similar_price_Listings').hide();
                jQuery('#Similar_type_Listings').hide();
                jQuery('#Similar_zipcode_Listings').hide();*/
                jQuery('#carousel').show();
                jQuery('#slider').show();
                // The slider being synced must be initialized first

                jQuery('#carousel').flexslider({
                    animation: "slide",
                    controlNav: false,
                    animationLoop: false,
                    slideshow: false,
                    itemWidth: 130,
                    itemMargin: 5,
                    asNavFor: '#slider',
                    start: function (slider) {
                        // lazy load
                        $(slider).find("img.lzl").each(function () {
                            var src = $(this).attr("data-lzl");
                            $(this).attr("src", src).removeAttr("data-lzl").removeClass("lzl");
                        });
                    },
                    before: function (slider) {
                        // lazy load
                        var slide = $(slider).find('.slides').children().eq(slider.animatingTo + 1).find('img');
                        var src = slide.attr("data-lzl");
                        slide.attr("src", src).removeAttr("data-lzl").removeClass("lzl");
                    }
                });


                jQuery('#slider').flexslider({
                    animation: "slide",
                    controlNav: false,
                    animationLoop: false,
                    slideshow: false,
                    sync: "#carousel",
                    start: function (slider) {
                        // lazy load
                        $(slider).find("img.lzl").each(function () {
                            var src = $(this).attr("data-lzl");
                            $(this).attr("src", src).removeAttr("data-lzl").removeClass("lzl");
                        });
                    },
                    before: function (slider) {
                        // lazy load
                        var slide = $(slider).find('.slides').children().eq(slider.animatingTo + 1).find('img');
                        var src = slide.attr("data-lzl");
                        slide.attr("src", src).removeAttr("data-lzl").removeClass("lzl");
                    }
                });


                //setTimeout(function () {
                //lazyload("carousel");
                //}, 1000);

                ptBarPosition();
                bindMortgageCalculator();
                progressBar();

                if (jQuery('#google-map').length) {
                    var objMapHolder = jQuery('#google-map #location');
                    var map_width = jQuery('.map_view').width();

                    jQuery('#google-map #location').css('width', map_width);
                    //$('#gmap').css('width',map_width);
                    setMap("location", objMapHolder.data('lat'), objMapHolder.data('long'), objMapHolder.data('title'));

                    jQuery('.MapView').unbind('click');
                    jQuery('.MapView').bind('click', function () {
                        map_full_view.setMapTypeId(google.maps.MapTypeId.ROADMAP);
                        panorama.setVisible(false);
                    });
                }

                jQuery('#Save_price').click(function () {
                    jQuery('#get-cashback').trigger('click');
                    jQuery('#Save_price').addClass('active');
                });
                jQuery('.close-custom').click(function () {
                    jQuery('.modal-backdrop').remove();
                    window.history.replaceState(null, null, jQuery('#currentURL').val());

                });
                rabateCalc();
                setTimeout(function () {
                    getsimilarproperty('Active');
                }, 1000);
                setTimeout(function () {
                    // getsimilarproperty('Closed');
                }, 2000);
                setTimeout(function () {
                    // lazyload("slider");
                    getzestimate();
                }, 3000);
                bindfrmInquiry();
                jQuery("#getcashback-close").on('click', function () {
                    jQuery("#sideopening").modal('hide');
                    jQuery('#Save_price').removeClass('active');
                });
                jQuery("#get-cashback,#get-cashback-2").on('click', function (e) {
                    jQuery("#sideopening").modal('show');
                });
                bindSchedulePopup();
                // ptBarPosition();
                /* doInputMasking();*/


            });
        }

    });


}

function getsimilarproperty(status, sptype){

    var send_data = [];
    if ((typeof(sptype) == undefined ) || (typeof(sptype) == 'undefined' )){
        sptype = '';
    }
    if(typeof arrRelProp != undefined && typeof arrRelProp != 'undefined'){
        var proparr = JSON.parse( arrRelProp  );
    }
    else{
        var proparr = [];
    }

    proparr['status'] = status;
    proparr['sptype'] = sptype;
    proparr['popupstatus'] = popup_status;

    /*proparr['zipcode'] = prozipcode;
    proparr['PropertyType'] = protype;
    proparr['ListPrice'] = proprice;*/
    $.each( proparr, function( key, value ) {
        send_data.push({name:key, value:value}) ;
    });
    // console.log(send_data+'--------------------------------');
    jQuery.jAjaxCall({
        abort_on_new_req    :   true,
        send_data           :   send_data,
        xhr_area            :   'SimilarProperties',
        xhr_module          :   'getsimilatproperties',
        //xhr_action        :   'L',
        xhr_url             :   Url_GAR,
        xhr_timeout         :   (1000*20),
        xhr_cross_domain    :   true,
        //xhr_data_type       :   "json",
        fn_alert            :   function (mt, m) {msgNotify(m,mt);},
        callbefore_send     : function (jqXHR, settings) {


        },
        callback_on_success : function (data, textStatus, jqXHR) {
            console.log('success');

            bindMDpopup();
            bindLGpopup();
            if (window.Highcharts != undefined) {
                window.Highcharts_4_1_9 = window.Highcharts; delete window.Highcharts;
            }
            bindCUSTOMpopup();
            $("#simi-price").click(function(){

                //getsimilarproperty('Active', 'sp-price');
                $('#Similar_price_Listings').removeClass('d-none');
                $('#Similar_price_Listings').css('display','block');
                //jQuery('#Similar_price_Listings').show();
                jQuery('#Similar_type_Listings').hide();
                jQuery('#Similar_zipcode_Listings').hide();
                jQuery('#Similar_Listings').hide();
            });

            $("#simi-type").click(function(){
                //getsimilarproperty('Active', 'sp-type' );
                jQuery('#Similar_price_Listings').hide();
                //jQuery('#Similar_type_Listings').show();
                $('#Similar_type_Listings').removeClass('d-none');
                $('#Similar_type_Listings').css('display','block');
                jQuery('#Similar_zipcode_Listings').hide();
                jQuery('#Similar_Listings').hide();
            });

            $("#simi-zipcode").click(function(){
                //getsimilarproperty('Active', 'sp-zipcode' );
                jQuery('#Similar_price_Listings').hide();
                jQuery('#Similar_type_Listings').hide();
                $('#Similar_zipcode_Listings').removeClass('d-none');
                $('#Similar_zipcode_Listings').css('display','block');
                //jQuery('#Similar_zipcode_Listings').show();
                jQuery('#Similar_Listings').hide();
            });

        },
        callback_on_error       : function (jqXHR, textStatus, errorThrown) {
            console.log('error');
        },
        callback_on_complete    : function (jqXHR, textStatus) {
            console.log('complete');
        }
    }, 'similarproperties');

}
function getzestimate(){
    var send_data = [];
    //console.log(addressFull, "addressFull")
    send_data.push({name:'addressfull', value:addressFull}) ;
    jQuery.jAjaxCall({
        abort_on_new_req    :   true,
        send_data           :   send_data,
        xhr_area            :   'ListingZestimate',
        xhr_module          :   'getlistingzestimate',
        //xhr_action        :   'L',
        xhr_url             :   Url_GAR,
        xhr_timeout         :   (1000*20),
        xhr_cross_domain    :   true,
        //xhr_data_type       :   "json",
        fn_alert            :   function (mt, m) {msgNotify(m,mt);},
        callbefore_send     : function (jqXHR, settings) {

        },
        callback_on_success : function (data, textStatus, jqXHR) {

        },
        callback_on_error       : function (jqXHR, textStatus, errorThrown) {

        },
        callback_on_complete    : function (jqXHR, textStatus) {
            setTimeout(function () {
                getsimilarproperty('Active', 'sp-price');
            }, 1000);
            setTimeout(function () {
                getsimilarproperty('Active', 'sp-type' );
            }, 2000);
            setTimeout(function () {
                getsimilarproperty('Active', 'sp-zipcode' );
            }, 3500);
        }
    }, 'zestimate');
}
function bindCUSTOMpopupHome()
{
    jQuery('.popup-modal-custom-home').unbind('click');
    jQuery('.popup-modal-custom-home').unbind().on('click',function(e){

        if(jQuery('#modal-popup-custom').is(":visible"))
        {
            jQuery('#modal-popup-custom').modal('hide');
            jQuery('#modal-popup-custom .modal-content').html('');
            jQuery('.modal-backdrop').remove();
            jQuery("#modal-popup-custom").removeAttr("style");

        }
        var url = jQuery(this).attr('data-url');
        var type = jQuery(this).attr('data-target');

        header_url = url.replace('popup','')
        window.history.replaceState(null, null, header_url);

        //   jQuery('#modal-popup-custom .modal-content').prepend('<button type="button" class="close" data-dismiss="modal" id="popup_close" aria-label="Close"><span aria-hidden="true">×</span></button>');
        jQuery('#modal-popup-custom .modal-content').html('<p class="text-center"><br>Loading ...</p>');

        jQuery('#modal-popup-custom').modal('show');

        jQuery('#modal-popup-custom .modal-content').load(Site_Root + url,function(e){

            jQuery('#carousel').show();
            jQuery('#slider').show();
            // The slider being synced must be initialized first
            jQuery('#carousel').flexslider({
                animation: "slide",
                controlNav: false,
                animationLoop: false,
                slideshow: false,
                itemWidth: 130,
                itemMargin: 5,
                asNavFor: '#slider',
                start: function (slider) {
                    // lazy load
                    $(slider).find("img.lzl").each(function () {
                        var src = $(this).attr("data-lzl");
                        $(this).attr("src", src).removeAttr("data-lzl").removeClass("lzl");
                    });
                },
                before: function (slider) {
                    // lazy load
                    var slide = $(slider).find('.slides').children().eq(slider.animatingTo+1).find('img');
                    var src = slide.attr("data-lzl");
                    slide.attr("src", src).removeAttr("data-lzl").removeClass("lzl");
                }

            });

            jQuery('#slider').flexslider({
                animation: "slide",
                controlNav: false,
                animationLoop: false,
                slideshow: false,
                sync: "#carousel",
                start: function (slider) {
                    // lazy load
                    $(slider).find("img.lzl").each(function () {
                        var src = $(this).attr("data-lzl");
                        $(this).attr("src", src).removeAttr("data-lzl").removeClass("lzl");
                    });
                },
                before: function (slider) {
                    // lazy load
                    var slide = $(slider).find('.slides').children().eq(slider.animatingTo+1).find('img');
                    var src = slide.attr("data-lzl");
                    slide.attr("src", src).removeAttr("data-lzl").removeClass("lzl");
                }
            });
            ptBarPosition();

            // ptBarPosition();
            /* doInputMasking();*/
            /*progressbar() now popup not available on home page then we don't need progress bar here*/
            bindMortgageCalculator();
            if(jQuery('#google-map').length)
            {
                var objMapHolder = jQuery('#google-map #location');
                var map_width = jQuery('.map_view').width();

                jQuery('#google-map #location').css('width',map_width);
                //$('#gmap').css('width',map_width);
                setMap("location", objMapHolder.data('lat'), objMapHolder.data('long'), objMapHolder.data('title'));

                jQuery('.MapView').unbind('click');
                jQuery('.MapView').bind('click', function(){
                    map_full_view.setMapTypeId(google.maps.MapTypeId.ROADMAP);
                    panorama.setVisible(false);
                });
            }

            jQuery('#Save_price').click(function () {
                jQuery('#get-cashback').trigger('click');
                jQuery('#Save_price').addClass('active');
            });
            jQuery('.close-custom').click(function () {
                jQuery('.modal-backdrop').remove();
                window.history.replaceState(null, null, Main_Host_Url);
            });
            rabateCalc();

            setTimeout(function () {
                getsimilarproperty('Active');
            }, 1000);
            setTimeout(function () {

                getsimilarproperty('Closed');
            }, 2000);

            setTimeout(function () {
                // lazyload("slider");
                getzestimate();
            }, 4000);
            bindfrmInquiry();
            jQuery("#getcashback-close").on('click',function(){
                jQuery("#sideopening").modal('hide');
            });
            jQuery("#get-cashback,#get-cashback-2").on('click',function(e){
                //console.log('get cash back');
                jQuery("#sideopening").modal('show');
            });
            bindSchedulePopup();
        });

    });
}

function bindSMpopup()
{
    jQuery('.popup-modal-sm').unbind('click');
    jQuery('.popup-modal-sm').on('click',function(){

        var url = jQuery(this).attr('data-url');
        var type = jQuery(this).attr('data-target');

        $('#modal-popup-sm .modal-content').html('<p class="text-center"><br>Loading ...</p>');
        $('#modal-popup-sm').modal('show');

        $('#modal-popup-sm .modal-content').load(Site_Root + url,function(e){
            bindSMpopup();
            bindMDpopup();
            bindLGpopup();
            bindCUSTOMpopup();
            doInputMasking();
            inquiryPopup();
            if(type == 'signup')
            {
                if(jQuery("#frmRegister").length)
                {
                    jQuery("#frmRegister").validate({
                        submitHandler: function(form) {
                            jQuery("#frmRegister button[type=submit]").attr('disabled', 'disabled');
                            var param = xajax.getFormValues('frmRegister');
                            if(parent.jQuery("input[name='OnPage']").length)
                                param['OnPage'] = parent.jQuery("input[name='OnPage']").val();
                            if(parent.jQuery("input[name='mlsNum']").length) // while we are not getting mls from url, need to fetch from hidden
                                param['mlsNum'] = parent.jQuery("input[name='mlsNum']").val();
                            xajax_ListingAjaxCall('User', 'Signup', param);
                            return false;
                        }
                    });
                }
            }
        });
    });
}
function bindSchedulePopup() {

    jQuery('.popup-modal-ss').unbind('click');
    jQuery('.popup-modal-ss').on('click',function(){

        var url = jQuery(this).attr('data-url');
        var type = jQuery(this).attr('data-target');

        jQuery('#modal-popup-ss .modal-content').html('<p class="text-center"><br>Loading ...</p>');
        jQuery('#modal-popup-ss').modal('show');


        jQuery('#modal-popup-ss .modal-content').load(url,function() {

            bindSchedulePopup();
            inquiryPopup();
            if(type == 'Schedule')
            {
                doInputMasking();
                bindDateTimePicker();
                if(jQuery("#form_Schedule").length > 0)
                {
                    jQuery("#form_Schedule").validate({
                        submitHandler: function(form) {

                            var send_data = jQuery("#form_Schedule").serializeArray();
                            jQuery.jAjaxCall({
                                send_data: send_data,
                                xhr_area: 'Property',
                                xhr_module: 'Schedule',
                                xhr_action: 'Schedule',
                                //xhr_url: '/ajax-request.php',
                                xhr_url: Url_GAR,
                                fn_alert: function(mt, m){
                                    msgNotify(m,mt,"#schedule-alert");
                                    loading(false,'.btn-schedule');
                                },
                                callbefore_send: function (jqXHR, settings) {
                                    loading(true,'.btn-schedule','.loading-schedule','<span class="text-primary">Please Wait ...</span>');
                                },
                                callback_on_success: function (data, textStatus, jqXHR) {
                                    if (typeof data.SUCCESS != 'undefined')
                                    {
                                        jQuery("#form_Schedule").trigger("reset");
                                        window.location.href = Main_Host_Url+"/thankyou.php"
                                    }
                                },
                                callback_on_error: function (jqXHR, textStatus, errorThrown) {},
                                callback_on_complete: function (jqXHR, textStatus) {

                                }
                            }, 'Schedule');

                            return false;

                        }
                    });
                }
                if(jQuery("#FLform_Schedule").length > 0)
                {

                    jQuery("#FLform_Schedule").validate({
                        submitHandler: function(form) {

                            var send_data = jQuery("#FLform_Schedule").serializeArray();
                            jQuery.jAjaxCall({
                                send_data: send_data,
                                xhr_area: 'FLInfo',
                                xhr_module: 'Schedule',
                                xhr_action: 'Schedule',
                                //xhr_url: '/ajax-request.php',
                                xhr_url: Url_GAR,
                                fn_alert: function(mt, m){
                                    msgNotify(m,mt,"#schedule-alert");
                                    loading(false,'.btn-schedule');
                                },
                                callbefore_send: function (jqXHR, settings) {
                                    loading(true,'.btn-schedule','.loading-schedule','<span class="text-primary">Please Wait ...</span>');
                                },
                                callback_on_success: function (data, textStatus, jqXHR) {
                                    if (typeof data.SUCCESS != 'undefined')
                                    {
                                        jQuery("#FLform_Schedule").trigger("reset");
                                        window.location.href = Main_Host_Url+"/thankyou.php"
                                    }
                                },
                                callback_on_error: function (jqXHR, textStatus, errorThrown) {},
                                callback_on_complete: function (jqXHR, textStatus) {

                                }
                            }, 'Schedule');

                            return false;

                        }
                    });
                }

            }
        });
    });
}

function bindMDpopup()
{

  
    jQuery('.popup-modal-md').unbind('click');
    jQuery('.popup-modal-md').on('click',function(){

        var url = jQuery(this).attr('data-url');
        var type = jQuery(this).attr('data-target');
       
        jQuery('#modal-popup-md .modal-content').html('<p class="text-center"><br>Loading ...</p>');
        jQuery('#modal-popup-md').modal('show');
        console.log(url);
        jQuery('#modal-popup-md .modal-content').load(url,function(){
            //$('#modal-popup-md').modal('show');
            //bindSMpopup();
            bindSMpopup();
            // bindMDpopup();
            bindLGpopup();
            bindCUSTOMpopup();
            bindDateTimePicker();
            //bindLGpopup();
            //doInputMasking();
            // BindDateTimePicker();
            HideCloseBtn();
            inquiryPopup();
            bindMDpopup();

            /*if(type == 'Schedule')
            {
                if(jQuery("#form_Schedule").length > 0)
                {
                    jQuery("#form_Schedule").validate({
                        submitHandler: function(form) {

                            var send_data = jQuery("#form_Schedule").serializeArray();
                            jQuery.jAjaxCall({
                                send_data: send_data,
                                xhr_area: 'Property',
                                xhr_module: 'Schedule',
                                xhr_action: 'Schedule',
                                //xhr_url: '/ajax-request.php',
                                xhr_url: Url_GAR,
                                fn_alert: function(mt, m){
                                    msgNotify(m,mt,"#schedule-alert");
                                    loading(false,'.btn-schedule');
                                },
                                callbefore_send: function (jqXHR, settings) {
                                    loading(true,'.btn-schedule','.loading-schedule','<span class="text-primary">Please Wait ...</span>');
                                },
                                callback_on_success: function (data, textStatus, jqXHR) {
                                    if (typeof data.SUCCESS != 'undefined')
                                    {
                                        jQuery("#form_Schedule").trigger("reset");
                                    }
                                },
                                callback_on_error: function (jqXHR, textStatus, errorThrown) {},
                                callback_on_complete: function (jqXHR, textStatus) {}
                            }, 'Schedule');

                            return false;

                        }
                    });
                }
            }*/
            if(type == 'QuickDealInquiry')
            {

                doInputMasking();
                reloadCaptcha('inq-captcha');
                if(jQuery("#frm-QuickDealInquiry").length > 0)
                {
                    jQuery("#frm-QuickDealInquiry").validate({
                        submitHandler: function(form) {

                            var send_data = jQuery("#frm-QuickDealInquiry").serializeArray();
                            jQuery.jAjaxCall({
                                send_data: send_data,
                                xhr_area: 'Property',
                                xhr_module: 'QuickDealInquiry',
                                xhr_action: '',
                                xhr_url: Url_GAR,
                                fn_alert: function(mt, m){
                                    msgNotify(m,mt,"#qd-alert-msg");
                                    loading(false,'#qd-loading-area');
                                },
                                callbefore_send: function (jqXHR, settings) {
                                    /*loading(true,'.btn-mc-form','.loading-area-inquiry','<span class="text-primary">Please Wait ...</span>');*/
                                    loading(true,'#qd-alert-msg','#qd-loading-area','<span class="text-primary">Please Wait ...</span>');
                                },
                                callback_on_success: function (data, textStatus, jqXHR) {
                                    if (typeof data.SUCCESS != 'undefined')
                                    {
                                        jQuery("#frm-QuickDealInquiry").trigger("reset");
                                    }
                                },
                                callback_on_error: function (jqXHR, textStatus, errorThrown) {},
                                callback_on_complete: function (jqXHR, textStatus) {
                                    process = false;
                                }
                            }, 'QuickDealInquiry');

                            return false;
                        }
                    });
                }
            }
            if(type == "signin")
            {
                if(jQuery("#frmLogin").length)
                {
                    jQuery("#frmLogin").validate({
                        submitHandler: function(form) {
                            var send_data = jQuery("#frmLogin").serializeArray();
                            if (parent.jQuery("input[name='OnPage']").val() != '')
                                send_data.push({name: 'OnPage', value: parent.jQuery("input[name='OnPage']").val()});
                            jQuery.jAjaxCall({
                                send_data: send_data,
                                xhr_area: 'User',
                                xhr_module: 'Login',
                                xhr_action: '',
                                xhr_url: Url_GAR,
                                xhr_timeout :   (1000*50),
                                fn_alert: function(mt, m){
                                    msgNotify(m,mt,"#login-error");
                                    loading(false,'.btn-signin');
                                },
                                callbefore_send: function (jqXHR, settings) {
                                    //loading(true,'.btn-signin','.loading-area','<span class="text-primary">Please Wait ...</span>');
                                },
                                callback_on_success: function (data, textStatus, jqXHR) {



                                    if (typeof data.SUCCESS != undefined && typeof data.SUCCESS != 'undefined') {
                                        jQuery("#frmLogin").trigger("reset");
                                    }
                                    if (typeof data.DATA != undefined && typeof data.DATA != 'undefined') {

                                        if (typeof data.DATA.ReloadResult != undefined && typeof data.DATA.ReloadResult != 'undefined' && data.DATA.ReloadResult == true) {
                                            // pt.reload_result();
                                        }
                                        if (typeof data.DATA.save_search != undefined && typeof data.DATA.save_search != 'undefined' && data.DATA.save_search == true) {
                                            //setTimeout('jQuery("#save_search").trigger("click");', 2000);
                                            setTimeout(function () {
                                                jQuery("#save_search").trigger("click");
                                            }, 2500)
                                        }

                                        if (data.DATA.type == 'sold') {

                                            setTimeout(function () {
                                                jQuery("#fullview_"+data.DATA.id).trigger("click");
                                            }, 2500)
                                        }
                                    }
                                },
                                callback_on_error: function (jqXHR, textStatus, errorThrown) {},
                                callback_on_complete: function (jqXHR, textStatus) {}
                            }, 'login');
                            return false;
                        }
                    });
                }
            }

            if(type == "signup"){
                if(jQuery("#frmRegister").length)
                {
                    doInputMasking();
                    reloadCaptcha('register-captcha');
                    jQuery("#frmRegister").validate({
                        submitHandler: function(form) {
                            var send_data = jQuery("#frmRegister").serializeArray();
                            //console.log(Url_GAR);
                            jQuery.jAjaxCall({
                                send_data: send_data,
                                xhr_area: 'User',
                                xhr_module: 'SignUp',
                                xhr_action: '',
                                xhr_url: Url_GAR,
                                xhr_timeout :   (1000*50),
                                fn_alert: function(mt, m){
                                    msgNotify(m,mt,"#signup-error");
                                    loading(false,'.btn-signup');
                                },
                                callbefore_send: function (jqXHR, settings) {
                                    loading(true,'.btn-signup','.loading-area','<span class="text-primary">Please Wait...</span>');
                                },
                                callback_on_success: function (data, textStatus, jqXHR) {
                                    if (typeof data.SUCCESS != 'undefined' && data.SUCCESS != undefined)
                                    {
                                        jQuery("#frmRegister").trigger("reset");
                                    }
                                },
                                callback_on_error: function (jqXHR, textStatus, errorThrown) {},
                                callback_on_complete: function (jqXHR, textStatus) {}
                            }, 'usersingnup');
                            return false;

                        }

                    });
                }
            }
            if(type == 'forgot_password')
            {
                if(jQuery("#frmForgetPwd").length)
                {
                    jQuery("#frmForgetPwd").validate({

                        submitHandler: function(form) {

                            //jQuery("#frmForgetPwd button[type=submit]").attr('disabled', 'disabled');
                            var send_data = jQuery("#frmForgetPwd").serializeArray();
                            if(parent.jQuery("input[name='OnPage']").length)
                                send_data.push({name:'OnPage',value:parent.jQuery("input[name='OnPage']").val()});
                            if(parent.jQuery("input[name='mlsNum']").length) // while we are not getting mls from url, need to fetch from hidden
                                send_data.push({name:'mlsNum',value:parent.jQuery("input[name='mlsNum']").val()});

                            jQuery.jAjaxCall({
                                send_data: send_data,
                                xhr_area: 'User',
                                xhr_module: 'ForgotPassword',
                                xhr_action: '',
                                xhr_url: Url_GAR,
                                fn_alert: function(mt, m){
                                    msgNotify(m,mt,"#forgot-error");
                                    loading(false,'.btn-fwd');
                                },
                                callbefore_send: function (jqXHR, settings) {
                                    loading(true,'.btn-fwd','.loading-area','<span class="text-primary">Please Wait ...</span>');
                                },
                                callback_on_success: function (data, textStatus, jqXHR) {
                                    if (typeof data.SUCCESS != 'undefined' && data.SUCCESS != undefined)
                                    {
                                        jQuery("#frmForgetPwd").trigger("reset");
                                    }
                                },
                                callback_on_error: function (jqXHR, textStatus, errorThrown) {},
                                callback_on_complete: function (jqXHR, textStatus) {}
                            }, 'forgetpassword');
                            return false;

                        }

                    });
                }
            }
            if(type == 'savesearch')
            {
                if(jQuery("#frmSaveSearch").length)
                {
                    jQuery("#frmSaveSearch").validate({

                        submitHandler: function(form) {

                            var send_data = jQuery("#frmSaveSearch").serializeArray();

                            jQuery.jAjaxCall({
                                send_data: send_data,
                                xhr_area: 'User',
                                xhr_module: 'SaveSearch',
                                xhr_action: '',
                                xhr_url: Url_GAR,
                                xhr_timeout : (1000*7),
                                fn_alert: function(mt, m){
                                    msgNotify(m,mt,"#save_search_response");
                                    loading(false,'.btn-savesearch');
                                },
                                callbefore_send: function (jqXHR, settings) {
                                    loading(true,'.btn-savesearch','.loading-area','<span class="text-primary">Please Wait ...</span>');
                                },
                                callback_on_success: function (data, textStatus, jqXHR) {
                                    if (typeof data.SUCCESS != 'undefined' && data.SUCCESS != undefined)
                                    {
                                        jQuery("#frmSaveSearch").trigger("reset");
                                    }

                                },
                                callback_on_error: function (jqXHR, textStatus, errorThrown) {},
                                callback_on_complete: function (jqXHR, textStatus) {
                                    setTimeout(function () {
                                        jQuery('#modal-popup-md').modal('hide');
                                    },800);
                                }
                            }, 'savesearch');
                            return false;
                        }

                    });
                }
            }


        });
    });
}

function bindLGpopup()
{
    jQuery('.popup-modal-lg').unbind('click');
    jQuery('.popup-modal-lg').on('click',function(){

        var url = jQuery(this).attr('data-url');
        var type = jQuery(this).attr('data-target');

        jQuery('#modal-popup-lg .modal-content').html('<p class="text-center"><br>Loading ...</p>');

        jQuery('#modal-popup-lg').modal('show');

        jQuery('#modal-popup-lg .modal-content').load(Site_Root + url,function(e){
            bindLGpopup();
            /* doInputMasking();*/
            bindDateTimePicker();
            inquiryPopup();
            if(type == 'Inquiry')
            {
                if(jQuery("#frm-Inquiry").length > 0)
                {
                    jQuery("#frm-Inquiry").validate({
                        submitHandler: function(form) {

                            var send_data = jQuery("#frm-Inquiry").serializeArray();

                            jQuery.jAjaxCall({
                                send_data: send_data,
                                xhr_area: 'Property',
                                xhr_module: 'Inquiry',
                                xhr_action: '',
                                //xhr_url: '/ajax-request.php',
                                xhr_url: Url_GAR,
                                fn_alert: function(mt, m){
                                    msgNotify(m,mt,"#message");
                                    loading(false,'.btn-p-inquiry');
                                },
                                callbefore_send: function (jqXHR, settings) {
                                    loading(true,'.btn-p-inquiry','.loading-area-inquiry','<span class="text-primary">Please Wait ...</span>');
                                },
                                callback_on_success: function (data, textStatus, jqXHR) {
                                    if (typeof data.SUCCESS != 'undefined')
                                    {
                                        jQuery("#frm-Inquiry").trigger("reset");
                                        window.location.href = Main_Host_Url+"/thankyou.php";
                                    }
                                },
                                callback_on_error: function (jqXHR, textStatus, errorThrown) {},
                                callback_on_complete: function (jqXHR, textStatus) {}
                            }, 'Inquiry');

                            return false;
                            // Disable Button
                            /*$("#frmInquiry button[type=submit]").attr('disabled', 'disabled');

                             // Show loading...
                             $("#msgPart").html('<div class="alert alert-info text-center"><strong>Please wait ...</strong></div>');
                             $("#msgPart").show();
                             var param = xajax.getFormValues('frmInquiry');

                             xajax_ListingAjaxCall('Listing', 'Inquiry', param);*/
                        }
                    });
                }
            }
            if(type == 'Share')
            {
                //console.log('share');
                if (window.addthis){
                    addthis.init();
                    addthis.layers.refresh();
                }
                jQuery("#frmEmailFriend").validate({
                    submitHandler: function(form) {
                        var send_data = jQuery("#frmEmailFriend").serializeArray();
                        jQuery.jAjaxCall({
                            send_data: send_data,
                            xhr_area: 'Property',
                            xhr_module: 'EmailToFriend',
                            xhr_action: '',
                            xhr_url: Url_GAR,
                            fn_alert: function(mt, m){
                                msgNotify(m,mt,"#email_message");
                                loading(false,'.btn-emailtofriend');
                            },
                            callbefore_send: function (jqXHR, settings) {
                                loading(true,'.btn-emailtofriend','.email-loading-area','<span class="text-primary">Please Wait ...</span>');
                            },
                            callback_on_success: function (data, textStatus, jqXHR) {
                                if (typeof data.SUCCESS != 'undefined')
                                {
                                    jQuery("#frmEmailFriend").trigger("reset");
                                    window.location.href = Main_Host_Url+"/thankyou.php";
                                }
                            },
                            callback_on_error: function (jqXHR, textStatus, errorThrown) {},
                            callback_on_complete: function (jqXHR, textStatus) {}

                        }, 'emailtofriend');
                        return false;
                    }
                });
            }
            if(type == 'PC-Share' || type == 'FL-Share')
            {
                jQuery("#frmEmailtoFriend").validate({
                    submitHandler: function(form) {

                        var send_data = jQuery("#frmEmailtoFriend").serializeArray();
                        send_data.push({name: 'module', value: type});

                        jQuery.jAjaxCall({
                            send_data: send_data,
                            xhr_area: 'Precons',
                            xhr_module: 'EmailToFriend',
                            xhr_action: '',
                            xhr_url: Url_GAR,
                            fn_alert: function(mt, m){
                                msgNotify(m,mt,"#email_message");
                                loading(false,'.btn-emailtofriend');
                            },
                            callbefore_send: function (jqXHR, settings) {
                                loading(true,'.btn-emailtofriend','.email-loading-area','<span class="text-primary">Please Wait ...</span>');
                            },
                            callback_on_success: function (data, textStatus, jqXHR) {
                                if (typeof data.SUCCESS != 'undefined')
                                {
                                    jQuery("#frmEmailtoFriend").trigger("reset");
                                    window.location.href = Main_Host_Url+"/thankyou.php";
                                }
                            },
                            callback_on_error: function (jqXHR, textStatus, errorThrown) {},
                            callback_on_complete: function (jqXHR, textStatus) {}

                        }, 'emailtofriend');
                        return false;
                    }
                });
            }
            if(type == 'PC-Inquiry'){

                jQuery("#PC-inquiryfrm").validate({
                    submitHandler: function (form) {

                        var send_data = jQuery("#PC-inquiryfrm").serializeArray();

                        jQuery.jAjaxCall({
                            send_data: send_data,
                            xhr_area: 'Precons',
                            xhr_module: 'Inquiry',
                            xhr_action: '',
                            //xhr_url: '/ajax-request.php',
                            xhr_url: Url_GAR,
                            fn_alert: function (mt, m) {
                                msgNotify(m, mt, "#message");
                                loading(false, '.btn-p-inquiry');
                            },
                            callbefore_send: function (jqXHR, settings) {
                                loading(true, '.btn-p-inquiry', '.loading-area-inquiry', '<span class="text-primary">Please Wait ...</span>');
                            },
                            callback_on_success: function (data, textStatus, jqXHR) {
                                if (typeof data.SUCCESS != 'undefined') {
                                    jQuery("#PC-inquiryfrm").trigger("reset");
                                    window.location.href = Main_Host_Url+"/thankyou.php";
                                }
                            },
                            callback_on_error: function (jqXHR, textStatus, errorThrown) {
                            },
                            callback_on_complete: function (jqXHR, textStatus) {
                            }
                        }, 'PCInquiry');

                        return false;

                        // Disable Button
                        /*$("#frmInquiry button[type=submit]").attr('disabled', 'disabled');

                         // Show loading...
                         $("#msgPart").html('<div class="alert alert-info text-center"><strong>Please wait ...</strong></div>');
                         $("#msgPart").show();
                         var param = xajax.getFormValues('frmInquiry');

                         xajax_ListingAjaxCall('Listing', 'Inquiry', param);*/
                    }
                });
            }

            if(type == 'EM-Inquiry')
            {
                if(jQuery("#form_EMInquiry").length > 0)
                {
                    jQuery("#form_EMInquiry").validate({
                        submitHandler: function(form) {

                            var send_data = jQuery("#form_EMInquiry").serializeArray();
                            jQuery.jAjaxCall({
                                send_data: send_data,
                                xhr_area: 'AajaxRequest',
                                xhr_module: 'EarnMore',
                                xhr_action: '',
                                //xhr_url: '/ajax-request.php',
                                xhr_url: Url_GAR,
                                fn_alert: function(mt, m){
                                    msgNotify(m,mt,"#em-alert");
                                    loading(false,'.btn-em');
                                },
                                callbefore_send: function (jqXHR, settings) {
                                    loading(true,'.btn-em','.loading-area','<span class="text-primary">Please Wait ...</span>');
                                },
                                callback_on_success: function (data, textStatus, jqXHR) {
                                    if (typeof data.SUCCESS != 'undefined')
                                    {
                                        jQuery("#form_EMInquiry").trigger("reset");
                                        window.location.href = Main_Host_Url+"/thankyou.php";
                                    }
                                },
                                callback_on_error: function (jqXHR, textStatus, errorThrown) {},
                                callback_on_complete: function (jqXHR, textStatus) {}
                            }, 'EMInquiry');

                            return false;

                        }
                    });
                }
            }
            if(type == 'Online-Bargain')
            {
                if(jQuery("#form_OBargain").length > 0)
                {
                    jQuery("#form_OBargain").validate({
                        submitHandler: function(form) {

                            var send_data = jQuery("#form_OBargain").serializeArray();

                            jQuery.jAjaxCall({
                                send_data: send_data,
                                xhr_area: 'AajaxRequest',
                                xhr_module: 'OnlineBargain',
                                xhr_action: '',
                                //xhr_url: '/ajax-request.php',
                                xhr_url: Url_GAR,
                                fn_alert: function(mt, m){
                                    msgNotify(m,mt,"#ob-alert");
                                    loading(false,'.btn-ob');
                                },
                                callbefore_send: function (jqXHR, settings) {
                                    loading(true,'.btn-ob','.loading-area','<span class="text-primary">Please Wait ...</span>');
                                },
                                callback_on_success: function (data, textStatus, jqXHR) {
                                    if (typeof data.SUCCESS != 'undefined')
                                    {
                                        jQuery("#form_OBargain").trigger("reset");
                                    }
                                },
                                callback_on_error: function (jqXHR, textStatus, errorThrown) {},
                                callback_on_complete: function (jqXHR, textStatus) {}
                            }, 'EMInquiry');

                            return false;

                        }
                    });
                }
            }
            if(type == 'NewConstruction')
            {
                if(jQuery("#form_PCLInquiry").length > 0)
                {
                    jQuery("#form_PCLInquiry").validate({
                        submitHandler: function(form) {

                            var send_data = jQuery("#form_PCLInquiry").serializeArray();
                            jQuery.jAjaxCall({
                                send_data: send_data,
                                xhr_area: 'AajaxRequest',
                                xhr_module: 'NewConstruction',
                                xhr_action: '',
                                //xhr_url: '/ajax-request.php',
                                xhr_url: Url_GAR,
                                fn_alert: function(mt, m){
                                    msgNotify(m,mt,"#pcl-alert");
                                    loading(false,'.btn-pcl');
                                },
                                callbefore_send: function (jqXHR, settings) {
                                    loading(true,'.btn-pcl','.loading-area','<span class="text-primary">Please Wait ...</span>');
                                },
                                callback_on_success: function (data, textStatus, jqXHR) {
                                    if (typeof data.SUCCESS != 'undefined')
                                    {
                                        jQuery("#form_PCLInquiry").trigger("reset");
                                    }
                                },
                                callback_on_error: function (jqXHR, textStatus, errorThrown) {},
                                callback_on_complete: function (jqXHR, textStatus) {}
                            }, 'EMInquiry');

                            return false;

                        }
                    });
                }
            }
            if(type == 'S-Inquiry')
            {
                if(jQuery("#form_SInquiry").length > 0)
                {
                    jQuery("#form_SInquiry").validate({
                        submitHandler: function(form) {

                            var send_data = jQuery("#form_SInquiry").serializeArray();

                            jQuery.jAjaxCall({
                                send_data: send_data,
                                xhr_area: 'AajaxRequest',
                                xhr_module: 'Sell',
                                xhr_action: '',
                                //xhr_url: '/ajax-request.php',
                                xhr_url: Url_GAR,
                                fn_alert: function(mt, m){
                                    msgNotify(m,mt,"#sell-alert");
                                    loading(false,'.btn-sell');
                                },
                                callbefore_send: function (jqXHR, settings) {
                                    loading(true,'.btn-sell','.loading-area','<span class="text-primary">Please Wait ...</span>');
                                },
                                callback_on_success: function (data, textStatus, jqXHR) {
                                    if (typeof data.SUCCESS != 'undefined')
                                    {
                                        jQuery("#form_SInquiry").trigger("reset");
                                        window.location.href = Main_Host_Url+"/thankyou.php";
                                    }
                                },
                                callback_on_error: function (jqXHR, textStatus, errorThrown) {},
                                callback_on_complete: function (jqXHR, textStatus) {}
                            }, 'SInquiry');

                            return false;

                        }
                    });
                }
            }
        });
    });
}
function bindDateTimePicker(sel)
{
    /* Get current datetime */
    var c_dt = new Date();
    if(!sel){sel = '.datetimepicker';}
    if(jQuery(sel).length > 0)
    {
        jQuery(sel).datetimepicker({
            format: 'd M yyyy HH:ii P',
            maskInput: true,
            weekStart: 1,
            todayBtn:  true,
            autoclose: true,
            todayHighlight: true,
            startView: 2,
            forceParse: true,
            showMeridian: true,
            minuteStep: 5,
            startDate:c_dt,
        });
    }
}

function HideCloseBtn()
{
    if (typeof ForceSignin != 'undefined' && ForceSignin == true && IsUserLogged == false)
    {
        setTimeout(function ()
        {
            jQuery('.fullview-model .close-btn').addClass('d-none');

        }, 50);
    }
}

function popupWindowURL(url, winname, w, h, menu, resize, scroll, toolBar, fullScreen)
{
    var x = (screen.width-w)/2;
    var y = (screen.height-h)/3;

    if (winname == null)
    {
        winname = "newWindow";
    }

    if (w == null)
    {
        w = 800;
    }

    if (h == null)
    {
        h = 600;
    }

    if (resize == null)
    {
        resize = 1;
    }

    menutype   = "nomenubar";
    resizetype = "noresizable";
    scrolltype = "noscrollbars";
    toolbar    = "no";

    if (menu)
    {
        menutype = "menubar";
    }

    if (resize)
    {
        resizetype = "resizable";
    }

    if (scroll)
    {
        scrolltype = "scrollbars";
    }

    if (toolBar)
    {
        toolbar = "yes";
    }

    if(fullScreen)
    {
        cwin = window.open(url,winname,"channelmode=1,fullscreen=1,toolbar=" + toolbar);
    }
    else
    {
        cwin = window.open(url,winname,"top=" + y + ",left=" + x + ",screenX=" + x + ",screenY=" + y + "," + "status," + menutype + "," + scrolltype + "," + resizetype + ",width=" + w + ",height=" + h+ ",toolbar=" + toolbar);
    }

    if (!cwin.opener)
    {
        cwin.opener = self;
    }

    cwin.focus();

    return true;
}
//==========================================================================================
// Function Name   :   reloadCaptcha
//==========================================================================================
function reloadCaptcha(el, key)
{
    jQuery("#code_of_image").val('');

    var d = new Date();
    var url = Site_Root + "/captcha.php?time="+ (d.getTime());
    if(key)
    {
        url += '&key='+key;
    }

    jQuery("#"+el).attr("src", url);
}
function lzl(){
    var container = window;
    if(jQuery('#lr-data').length > 0)
        container = jQuery('#lr-data');
    
    jQuery('img.lzl').show().lazyload({
        data_attribute:'lzl',
        failure_limit:20,
        threshold : 700,
        //effect:"fadeIn",
        skip_invisible:true,
        container:container,
    });
}
function LoadSignInUpPage()
{
   // console.log('login load');
    var hash =  window.location.hash;
    //console.log(hash);
    if(hash == UrlSignInPage)
    {
        //console.log('signin form');
        jQuery('#modal-login-form').trigger('click');
    }
    else if(hash == UrlSignUpPage)
    {
        //console.log('signup');
        jQuery('#modal-siunup-form').trigger('click');
    }
}
/*jQuery(document).ajaxStop(function(){
 lzl();
 });*/
jQuery(document).ajaxStop(function(){
    lzl();

    // setTimeout("jQuery('#lr-data').trigger('scroll');",500);


});
//====================================================================================================
//	Function Name	:	numberFormat
//----------------------------------------------------------------------------------------------------
function numberFormat(nStr)
{
    nStr += '';
    x = nStr.split('.');
    x1 = x[0];
    x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;

    while (rgx.test(x1))
    {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }

    return x1 + x2;
}
function UpdateFavorites_Click(MLS_No, Action, type)
{
    var isRedirect = jQuery("#isredirect").val();
    var send_data = [];
    send_data.push({name:'mls_no',value:MLS_No});
    send_data.push({name:'isredirect',value:isRedirect});
    send_data.push({name:'page_type',value:type});
    send_data.push({name:'action',value:Action});
    jQuery.jAjaxCall({
        send_data   :   send_data,
        xhr_area    :   'User',
        xhr_module  :   'UserFavourites',
        xhr_action  :   '',
        xhr_url     :   Url_GAR,
        callback_on_success: function (data, textStatus, jqXHR) {

            //jQuery("#form_"+MLS_No).trigger("reset");
            // jQuery("form").trigger("reset");

            // if (Action == "Add" && type='FL-FullView')
            // {
            //     jQuery(data.DATA.addclass2).html(data.DATA.link2);
            //     jQuery(data.DATA.addclass).html(data.DATA.link);
            // }
            // else if (Action == "Remove" && type='FL-FullView')
            // {
            //     jQuery(data.DATA.addclass2).html(data.DATA.link2);
            //     jQuery(data.DATA.addclass).html(data.DATA.link);
            // }
            if(type == 'MyFavListings' || type == 'PC-MyFavListings' || type == 'C-MyFavListings' || type == 'FL-FullView')
            {
                location.reload();
            }
        },
    }, 'userfav');
}
jQuery(document).ready(function(){
    console.log('common--.js');
    console.log('map-test--.js');
    // jQuery(window).scroll();
    
    lzl();
    /*jQuery(document).ajaxSend(function(){
        console.log('ajax-send');
        lzl();
    });
    jQuery(document).ajaxComplete(function(){
        console.log('ajax-complete');
        lzl();
    });*/
    
    /*$(".has-sub-child").closest("li").addClass("mega-menu");*/
    /*$(".has-child.mega-menu").hover(
        function(e) {
            e.preventDefault();
        });*/
    //$(".has-sub-child").closest(".main-menu").addClass("mega-menu");

    jQuery('#Save_price').click(function () {
        jQuery('#get-cashback').trigger('click');
        jQuery('#Save_price').addClass('active');
    });


    jQuery('body.homepage').click(function(e) {
    if (jQuery('#modal-popup-custom').hasClass('show') === true){
        var modal = document.querySelector('.modal');

        document.addEventListener('click', function(e) {
            var clickInside = modal.contains(e.target);

              if (!$(".homepage .modal").hasClass("show")) {
                if (!clickInside) {
                    window.history.replaceState(null, null, jQuery('#homeurl').val());
                }
            }
        });
    }
    });
    jQuery( ".idxwrapper" ).live( "click", function() {
        if (jQuery('#modal-popup-custom').hasClass('show') === true){
            var modal = document.querySelector('.modal');

            document.addEventListener('click', function(e) {
                var clickInside = modal.contains(e.target);

                if (!$(".idxwrapper .modal").hasClass("show")){
                    if (!clickInside) {
                        window.history.replaceState(null, null, jQuery('#currentURL').val());
                    }
                }
            });
        }

    });

    bind_address_autosuggest();
    bindLGpopup();
    bindMDpopup();
    
    bindCUSTOMpopup();
    bindSchedulePopup();
    
    // bindLRBar();
    //searchFilterPriceHtmlSet();
    lzl();
    inquiryPopup();
    if((jQuery(window).width()<=1200))
    {
        //console.log('hhjghjg');
        jQuery('.Mobile').show();
        jQuery('.mobile-hide').addClass('d-none');
        jQuery('ul.navigation').css('height','auto');
    }
    /*
     bindSelectize();
     bindLRBar();*/
    /*jQuery(document).on('click',"a#SchedualeTour,a#HomeValuation,a#MortgageClac",function(){
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top -50
        }, 2200);
    });*/
    /*    jQuery('#frmEmailFriend').load(function(){

        });*/


    jQuery(document).on("click", "a#SchedualeTour,a#HomeValuation,a#MortgageClac,a#RequestPropertyAnalysis,a#DealScore", function(e) {
        $("html, body").animate({
            scrollTop: $($.attr(this, "href")).offset().top - 240
        }, 800)
    });

    if(jQuery('.AddressName').length)
    {
        jQuery('.AddressName').on('keydown', function(event){
            // Enter key hit form submit

            if(event.keyCode == 13)
            {
                jQuery('.search_btn').click();
            }

            //when hit backspace
            if(event.keyCode == 8 || event.keyCode == 46)
            {
                var $select = $('#AddressName').selectize();
                var control = $select[0].selectize;

                control.clearOptions();
                control.refreshOptions(true);
                control.addOption([{type: 'cur_loc', title: 'Current Location'}]);
            }
        });
    }
    jQuery('.selectize-dropdown').removeClass('form-control');

    if(window.location.href.indexOf('acc=true') != '-1')
    {
        jQuery('button#modal-login-form').trigger('click');
        setTimeout(function(){

            var msg = "Your account is activated. Please login now.";
            var malert= '<div class="alert alert-success alert-dismissible fade show" role="alert"> '+msg+' <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button>--> </div>';
            jQuery('#login-error').html(malert);
        },1000);
    }
    else if(window.location.href.indexOf('acc=false') != '-1'){
        //console.log('acc-false')
        jQuery('button#modal-login-form').trigger('click');
        setTimeout(function(){
            //console.log('botton-login');
            var msg = "Welcome to Realstoria.com - we’re glad you’re here!";
            var malert= '<div class="alert alert-success alert-dismissible fade show" role="alert"> '+msg+' <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button>--> </div>';
            jQuery('#login-error').html(malert);
        },1000);
    }

    setTimeout(function(){
        LoadSignInUpPage();
    },1000);
    if(Isdisplaybanner == 'Yes'){
        $(".site-banner").removeClass("d-none");
        var headerHeight = $("header#page-header nav").outerHeight(true) +  $(".site-banner").outerHeight(true);
        $("#page-content").css({
            "top" : headerHeight + 'px',
        });
    }
    jQuery('#siteBannerClose').on('click',function(){

        jQuery.jAjaxCall({
            send_data: [],
            xhr_area: 'AajaxRequest',
            xhr_module: 'Sellbannerclose',
            xhr_action: '',
            xhr_url: Url_GAR,
            fn_alert: function(mt, m){
                //msgNotify(m,mt,"#qd-alert-msg");
                //loading(false,'#qd-loading-area');
            },
            callbefore_send: function (jqXHR, settings) {
                //loading(true,'#qd-alert-msg','#qd-loading-area','<span class="text-primary">Please Wait ...</span>');
            },
            callback_on_success: function (data, textStatus, jqXHR) {
                if (typeof data.SUCCESS != 'undefined')
                {
                    Isdisplaybanner =data.DATA.Isdisplaybanner;
                    if(Isdisplaybanner == 'No'){
                        $(".site-banner").addClass("d-none");
                        var headerHeight = $("header#page-header nav").outerHeight(true);
                        $("#page-content").css({
                            "top" : headerHeight + 'px',
                        })
                        if($.isFunction(window.setMapHeight))
                        {
                            setMapHeight();
                            setRPHeight();
                        }
                        //location.reload(true);
                    }
                }
            },
            callback_on_error: function (jqXHR, textStatus, errorThrown) {},
            callback_on_complete: function (jqXHR, textStatus) {
                process = false;
            }
        }, 'Sellbannerclose');

        return false;
    });



    jQuery('#modal-popup-custom').on('hidden.bs.modal', function (event) {

        if(event.target.id == 'modal-popup-custom')
        {
            jQuery('#modal-popup-custom .modal-content').html('');
            jQuery("#modal-popup-custom").removeAttr("style");
            if(is_search == true)
            {
                isBackSearch=1;
                if(total_record != 1) {
                    if (jQuery("#cur_page")) {
                        getPage(jQuery('#cur_page').val(), 'ms-filter-form');
                    } else {
                        getPage(1, 'ms-filter-form');
                    }
                    //jQuery('.dropdown-toggle').dropdown('dispose');
                    //jQuery('.dropdown-toggle').dropdown();

                    // jQuery('.dropdown-toggle').dropdown();
                }
            }

            // getsimilarproperty('Closed');
            //('Closed');
        }
        else if(event.target.id == 'sideopening')
        {
            if(jQuery('#modal-popup-custom').is(":visible"))
            {
                //jQuery('#sideopening').modal('hide');
                //jQuery('.modal-backdrop').remove();
                jQuery("#sideopening").removeAttr("style");

            }
        }


    });

    jQuery("#search-main-field-button").on("click",function(){
        if(jQuery(".search-main-field").val() == '' ){
            event.preventDefault();
            //$("#search").submit();
        }
    });

    /*if (typeof(jQuery("#UserloggedIn").val()) != undefined && jQuery("#UserloggedIn").val() != '' && jQuery("#UserloggedIn").val() == 'false') {
        if (typeof (citypage) != undefined && citypage != '' && citypage == true) {

            setTimeout(function () {
                var url = jQuery('#site-login #modal-login-form').attr('data-url');
                var type = jQuery('#site-login #modal-login-form').attr('data-target');

                jQuery('#modal-popup-md .modal-content').html('<p class="text-center"><br>Loading ...</p>');
                jQuery('#modal-popup-md').modal('show');

                jQuery('#modal-popup-md .modal-content').load(url,function(){
                    if (typeof(type) != undefined && type != '')
                        forcedSignInPopup(type);
                });
            }, 6000);
        }
    }*/

});


function html_pager_responsive(total_page, cur_page)
{
    if (total_page == 1){
        $("#lr-pagination").css("display", "none");
    }
    var total_limit = 5;
    var before_page_limit = 3;
    var after_page_limit = 1;

    var initial_page   = parseInt(cur_page) - parseInt(before_page_limit);
    var end_page       = parseInt(cur_page) + parseInt(after_page_limit);

    var page_string = '';
    /* All pages before curent page */
    if(initial_page > 0) {
        initial_page = (cur_page == total_page && total_page > 5)?initial_page-1:initial_page;

        for(i=initial_page; i<cur_page; i++)
        {
            page_string += '<li><a data-page="'+ i +'" class="page-link" title="'+ i +'">' + i + '</a></li>';
        }
    }
    else if(cur_page > 1 && cur_page <= before_page_limit)
    {
        var from = before_page_limit - cur_page;
        from = (from == 0)?1:from;
        for(i=from; i<cur_page; i++)
        {
            page_string += '<li><a data-page="'+ i +'" class="page-link" title="'+ i +'">' + i + '</a></li>';
        }
    }
    /* Current page*/
    page_string += '<li class="active"><a class="page-link">'+cur_page+'</a></li>';
    if(cur_page >= total_limit && (end_page < total_page || end_page == total_page))
    {
        page_string += '<li><a data-page="'+ end_page +'" class="page-link" title="'+ i +'">' + end_page + '</a></li>';
    }
    else if(cur_page < total_limit)
    {
        var a = parseInt(total_limit) - parseInt(cur_page);
        var from = parseInt(cur_page) + 1;
        var to =  parseInt(cur_page) + a;

        to = (to <= parseInt(total_page))?to:parseInt(total_page);
        for(i=from; i<=to; i++)
        {
            page_string += '<li><a data-page="'+ i +'" class="page-link" title="'+ i +'">' + i + '</a></li>';
        }
    }

    var pager_string = '';
    if( cur_page > 1 )
    {
        pager_string += '<li><a data-page="'+(parseInt(cur_page) - 1)+'" class="page-link" title="'+(parseInt(cur_page) - 1)+'"><i class="fa fa-chevron-left"></i></a></li>'
            + page_string;
    }
    else{
        pager_string += '<li class="disabled"><a href="JavaScript: void(0);" class="page-link" title="left"><i class="fa fa-chevron-left"></i></a></li>'
            + page_string;
    }
    if( cur_page < total_page )
    {
        pager_string += '<li><a data-page="'+ (parseInt(cur_page) + 1)+'" class="page-link" title="'+(parseInt(cur_page) + 1)+'"><i class="fa fa-chevron-right"></i></a></li>';
    }
    else{
        pager_string += '<li class="disabled"><a href="JavaScript: void(0);" class="page-link" title="right"><i class="fa fa-chevron-right"></i></a></li>';
    }
    return pager_string;
}
function bindmPrice()
{
    //if(jQuery('#m-price').is(":visible"))
    //{
    jQuery('#m-price').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        nextArrow: '<button type="button" class="slick-next">&#10095;</button>',
        prevArrow: '<button type="button" class="slick-prev">&#10094;</button>',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,

                }
            },
            {
                breakpoint: 736,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1

                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1

                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1

                }
            },
            {
                breakpoint: 414,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1

                }
            },
            {
                breakpoint: 375,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }

        ]
    });
    //}
}


function inquiryPopup() {
    // setTimeout(function(){
    //     if(!jQuery("#modal-popup-lg").hasClass("show") && !jQuery("#modal-popup-md").hasClass("show") && !jQuery("#modal-popup-ss").hasClass("show") && !jQuery("#modal-popup-sm").hasClass("show") && jQuery("#modal-popup-custom").hasClass("show")){
    //         jQuery("#inquiry-frm").trigger('click');
    //     }
    // },60000);
}
function forcedSignInPopup(type) {
    if(type == "signin")
    {
        if(jQuery("#frmLogin").length)
        {
            jQuery("#frmLogin").validate({
                submitHandler: function(form) {
                    var send_data = jQuery("#frmLogin").serializeArray();
                    if (parent.jQuery("input[name='OnPage']").val() != '')
                        send_data.push({name: 'OnPage', value: parent.jQuery("input[name='OnPage']").val()});
                    jQuery.jAjaxCall({
                        send_data: send_data,
                        xhr_area: 'User',
                        xhr_module: 'Login',
                        xhr_action: '',
                        xhr_url: Url_GAR,
                        xhr_timeout :   (1000*50),
                        fn_alert: function(mt, m){
                            msgNotify(m,mt,"#login-error");
                            loading(false,'.btn-signin');
                        },
                        callbefore_send: function (jqXHR, settings) {
                            //loading(true,'.btn-signin','.loading-area','<span class="text-primary">Please Wait ...</span>');
                        },
                        callback_on_success: function (data, textStatus, jqXHR) {



                            if (typeof data.SUCCESS != undefined && typeof data.SUCCESS != 'undefined') {
                                jQuery("#frmLogin").trigger("reset");
                            }
                            if (typeof data.DATA != undefined && typeof data.DATA != 'undefined') {

                                if (typeof data.DATA.ReloadResult != undefined && typeof data.DATA.ReloadResult != 'undefined' && data.DATA.ReloadResult == true) {
                                    // pt.reload_result();
                                }
                                if (typeof data.DATA.save_search != undefined && typeof data.DATA.save_search != 'undefined' && data.DATA.save_search == true) {
                                    //setTimeout('jQuery("#save_search").trigger("click");', 2000);
                                    setTimeout(function () {
                                        jQuery("#save_search").trigger("click");
                                    }, 2500)
                                }

                                if (data.DATA.type == 'sold') {

                                    setTimeout(function () {
                                        jQuery("#fullview_"+data.DATA.id).trigger("click");
                                    }, 2500)
                                }
                            }
                        },
                        callback_on_error: function (jqXHR, textStatus, errorThrown) {},
                        callback_on_complete: function (jqXHR, textStatus) {}
                    }, 'login');
                    return false;
                }
            });
        }
    }

    if(type == "signup"){
        if(jQuery("#frmRegister").length)
        {
            doInputMasking();
            reloadCaptcha('register-captcha');
            jQuery("#frmRegister").validate({
                submitHandler: function(form) {
                    var send_data = jQuery("#frmRegister").serializeArray();
                    //console.log(Url_GAR);
                    jQuery.jAjaxCall({
                        send_data: send_data,
                        xhr_area: 'User',
                        xhr_module: 'SignUp',
                        xhr_action: '',
                        xhr_url: Url_GAR,
                        xhr_timeout :   (1000*50),
                        fn_alert: function(mt, m){
                            msgNotify(m,mt,"#signup-error");
                            loading(false,'.btn-signup');
                        },
                        callbefore_send: function (jqXHR, settings) {
                            loading(true,'.btn-signup','.loading-area','<span class="text-primary">Please Wait...</span>');
                        },
                        callback_on_success: function (data, textStatus, jqXHR) {
                            if (typeof data.SUCCESS != 'undefined' && data.SUCCESS != undefined)
                            {
                                jQuery("#frmRegister").trigger("reset");
                            }
                        },
                        callback_on_error: function (jqXHR, textStatus, errorThrown) {},
                        callback_on_complete: function (jqXHR, textStatus) {}
                    }, 'usersingnup');
                    return false;

                }

            });
        }
    }
    if(type == 'forgot_password')
    {
        if(jQuery("#frmForgetPwd").length)
        {
            jQuery("#frmForgetPwd").validate({

                submitHandler: function(form) {

                    //jQuery("#frmForgetPwd button[type=submit]").attr('disabled', 'disabled');
                    var send_data = jQuery("#frmForgetPwd").serializeArray();
                    if(parent.jQuery("input[name='OnPage']").length)
                        send_data.push({name:'OnPage',value:parent.jQuery("input[name='OnPage']").val()});
                    if(parent.jQuery("input[name='mlsNum']").length) // while we are not getting mls from url, need to fetch from hidden
                        send_data.push({name:'mlsNum',value:parent.jQuery("input[name='mlsNum']").val()});

                    jQuery.jAjaxCall({
                        send_data: send_data,
                        xhr_area: 'User',
                        xhr_module: 'ForgotPassword',
                        xhr_action: '',
                        xhr_url: Url_GAR,
                        fn_alert: function(mt, m){
                            msgNotify(m,mt,"#forgot-error");
                            loading(false,'.btn-fwd');
                        },
                        callbefore_send: function (jqXHR, settings) {
                            loading(true,'.btn-fwd','.loading-area','<span class="text-primary">Please Wait ...</span>');
                        },
                        callback_on_success: function (data, textStatus, jqXHR) {
                            if (typeof data.SUCCESS != 'undefined' && data.SUCCESS != undefined)
                            {
                                jQuery("#frmForgetPwd").trigger("reset");
                            }
                        },
                        callback_on_error: function (jqXHR, textStatus, errorThrown) {},
                        callback_on_complete: function (jqXHR, textStatus) {}
                    }, 'forgetpassword');
                    return false;
                }
            });
        }
    }

}
